import React, { memo } from 'react';
import PropTypes from 'prop-types';
import playSprite from 'assets/icons/play.svg';

import {
  PosterStyled,
  BackLayoutWrap,
  Trailer,
  StyledImg,
  PlaceholderIcon,
  StyledText,
  StyledIcon,
  SubscriptionWrapper,
  SubscriptionImg,
  SubscriptionImgWrap,
} from './styles/PosterStyled';

const Poster = ({ translate, onPlayTrailer, mainPoster, trailer, posters, subscription }) => {
  const renderTrailer = () => (
    <Trailer onClick={onPlayTrailer}>
      <StyledIcon name={playSprite.id} size={14} />
      <StyledText type="uppercase" font="din_bold" color="white">
        {translate('watch')}
        <br />
        {translate('trailer')}
      </StyledText>
    </Trailer>
  );

  const renderPosterWithTrailer = (posterType) => (
    <BackLayoutWrap type={posterType}>
      <PlaceholderIcon
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 32 32"
      >
        <path
          fill="#fff"
          d="M1.733 0h28.4c1.067 0 1.867 0.8 1.867 1.733v28.4c0 0.933-0.8 1.733-1.733 1.733h-28.533c-0.933 0.133-1.733-0.667-1.733-1.6v-28.533c0-0.933 0.8-1.733 1.733-1.733zM26.667 9.333h2.667v-6.667h-2.667v6.667zM8 14.667h16v-12h-16v12zM2.667 9.333h2.667v-6.667h-2.667v6.667zM26.667 20h2.667v-8h-2.667v8zM2.667 20h2.667v-8h-2.667v8zM8 29.333h16v-12h-16v12zM26.667 29.333h2.667v-6.667h-2.667v6.667zM2.667 29.333h2.667v-6.667h-2.667v6.667z"
        />
      </PlaceholderIcon>
      <StyledImg
        style={{
          backgroundImage: `url(${mainPoster})`,
        }}
      />
      {trailer && renderTrailer()}
    </BackLayoutWrap>
  );

  const renderPoster = () => (
    <PosterStyled>
      {subscription && posters.length !== 0 ? (
        <SubscriptionWrapper>
          {posters.map((item) => (
            <SubscriptionImgWrap key={item.id}>
              <SubscriptionImg
                style={{
                  backgroundImage: `url(${item.src})`,
                }}
              />
            </SubscriptionImgWrap>
          ))}
          {renderPosterWithTrailer('subscriptionPoster')}
        </SubscriptionWrapper>
      ) : (
        renderPosterWithTrailer()
      )}
    </PosterStyled>
  );

  return renderPoster();
};

Poster.propTypes = {
  mainPoster: PropTypes.string,
  trailer: PropTypes.bool,
  subscription: PropTypes.bool,
  onPlayTrailer: PropTypes.func,
  posters: PropTypes.array,
  translate: PropTypes.func,
};

Poster.defaultProps = {
  mainPoster: '',
  trailer: false,
  subscription: false,
  onPlayTrailer: Function.prototype,
  translate: Function.prototype,
  posters: [
    {
      id: 1,
      src: '',
    },
    {
      id: 2,
      src: '',
    },
    {
      id: 3,
      src: '',
    },
    {
      id: 4,
      src: '',
    },
    {
      id: 5,
      src: '',
    },
    {
      id: 6,
      src: '',
    },
    {
      id: 7,
      src: '',
    },
    {
      id: 8,
      src: '',
    },
  ],
};

export default memo(Poster);
